import { DrawerBase } from 'bog-arcade-core-ui/core/DrawerBase';
import { mobileConfig } from '../../../core/applicationConfig';
import { mobileSourceNames } from '../../../core/sourceNames';
import { resourceHelper } from '../../../core/resourceHelper';
import { BigWinCoinsAnimation, BigWinWordAnimation } from '../../../core/enums';
import { bigWinService } from '../../../services/helperServices/BigWinService';
import { delay } from 'bog-arcade-core-ui/helpers';
import { NumberGrowService } from '../../../services/helperServices/NumberGrowService';
import { getAmount } from '../../../core/helpers/getAmount';
import { amountTextStyle } from '../../../core/textStyles';
import { bigWinAmountFontSizeHelper, handleBigWinClick } from '../helpers';

export class BaseBigWinPopup extends DrawerBase {
  constructor() {
    super();
  }

  getPopup(
    {
      parentWidth = mobileConfig.width,
      parentHeight = mobileConfig.height,
      names: {
        wordTextureName = mobileSourceNames.bigWinWordsSpine,
        coinsTextureName = mobileSourceNames.bigWinCoinsSpine,
      } = {},
      config: {
        position = mobileConfig.staticAnimationPosition,
        textPosition = { x: parentWidth / 2, y: 810 },
      } = {},
    } = {},
  ) {
    const content = this.createContainer('bigWinPopup');
    const animationsContent = this.createContainer('animationsContent');
    const rect = this.createGraphics().beginFill(0x000000).drawRect(0, 0, parentWidth, parentHeight).endFill();
    rect.alpha = 0;
    const amountTexture = this.createText('', {
      ...amountTextStyle,
      fontSize: 100,
    });
    amountTexture.anchor.set(.5);

    content.addChild(
      animationsContent,
      amountTexture,
      rect,
    );

    this.setupButtonMode(rect);
    this.registerClick(rect, event => {
      event.stopPropagation();
      handleBigWinClick(event, this);
    });

    this.addSubscriber(bigWinService.subscribe(state => {
      content.visible = state;
      if (state) {
        animationsContent.removeChildren();
        const coinsSpineTexture = this.createSpine(resourceHelper.get(coinsTextureName));
        const wordSpineTexture = this.createSpine(resourceHelper.get(wordTextureName));
        wordSpineTexture.state.timeScale = 1.2;

        this.start = Date.now();
        this.amountGrow = new NumberGrowService({
          min: 0,
          max: bigWinService.amount,
          delay: 6,
          stepDelay: .05,
        });
        this.amountGrow.subscribe(value => {
          const amountValue = getAmount(value);
          amountTexture.text = amountValue;
          bigWinAmountFontSizeHelper(amountTexture, amountValue);
        });
        const wordAnimation = bigWinService.animation;
        coinsSpineTexture.visible = false;

        delay(() => {
          animationsContent.addChild(
            coinsSpineTexture,
            wordSpineTexture,
          );
          wordSpineTexture.state.setAnimation(0, wordAnimation, false);
        }, 500);

        delay(() => {
          this.amountGrow.start();
          coinsSpineTexture.visible = true;
          coinsSpineTexture.state.setAnimation(0, BigWinCoinsAnimation.beginning, false);
          coinsSpineTexture.state.setAnimation(1, BigWinCoinsAnimation.loop, true);
        }, 2500);
      } else {
        amountTexture.text = '';
        animationsContent.removeChildren();
      }
    }));

    this.setPosition(animationsContent, position);
    this.setPosition(amountTexture, textPosition);

    return content;
  }

  checkTime() {
    const time = Date.now();
    return time - this.start >= 3000;
  }
}
